/*!
 * Main web js
 */

// import { ar } from 'date-fns/locale';

// variables
const web = window.web || {};
const dataLayer = window.dataLayer || [];
const ar = window.ar || {};
// window.bootstrap = bootstrap;

// functions

  function scrollToSection($, id) {
    var targetSec = $(
      '.block-item[data-section="' + id + '"], .bhr-year-heading[data-section="' + id + '"]',
    );
    if (targetSec.length) {
      var offset = targetSec.offset();
      $('html,body').animate(
        { scrollTop: offset.top - ($('.main-nav').length ? $('.main-nav').height() : 0) },
        800,
        function () {
          //
        },
      );
    }
  }

// function getnavposition($) {
//   var pagePositionUrl;
//   var scrollp = $(window).scrollTop();
//   $('.block-item').each(function (index) {
//     var offset = $(this).offset();
//     var blockStart = offset.top - 200;
//     var blockEnd = blockStart + $(this).height();

//     var elemID = $(this).attr('data-section');
//     if (typeof elemID !== 'undefined') {
//       var menuelem = $('.main-nav-menu .nav-link[href$="#' + elemID + '"]');
//       if (scrollp >= blockStart && scrollp < blockEnd) {
//         menuelem.closest('.nav-item').addClass('active');
//         if (pagePositionUrl !== elemID) {
//           pagePositionUrl = elemID;
//         }
//       } else {
//         menuelem.closest('.nav-item').removeClass('active');
//       }
//     }
//   });
// }

// function mainNavigationPosition() {
//   var html = $('html');
//   var windowScroll = html[0].scrollTop;
//   var wpAdminBar = $('#wpadminbar');
//   var topSpan = 0 + wpAdminBar.height();
//   var navigationSticky = $('#top-navigation-wrapper.sticky');
//   var mastHead = $('#masthead');

//   if (wpAdminBar) {
//     navigationSticky.css({ top: topSpan });
//   }

//   if (windowScroll > 0) {
//     html.addClass('top-navigation-sticked');
//     navigationSticky.addClass('sticked');
//     // mastHead.css({ paddingBottom: $('#top-navigation-wrapper.sticky').height() + 0 });
//   } else {
//     html.removeClass('top-navigation-sticked');
//     navigationSticky.removeClass('sticked');
//     // mastHead.css({ paddingBottom: 0 });
//   }
// }

// function testValidEmail(email) {
//   return /^[a-z_0-9.+-]+?@[a-z_0-9.-]+?\.[a-z_0-9.-]+?$/i.test(email);
// }

// function testIfEmpty(s) {
//   return /^\s*$/i.test(s) || s === '';
// }

// // lazyload
// function lazyloadImages() {
//   var lazyloadImagesList = $('img[data-src]');
//   if (lazyloadImagesList.length) {
//     var scrollTop = $(document).scrollTop();
//     var viewPortH = window.innerHeight;
//     lazyloadImagesList.each(function (i) {
//       var t = $(this);
//       var tTop = t.offset().top;
//       if (tTop < scrollTop + viewPortH + 50) {
//         t.attr('src', t.attr('data-src')).attr('data-src', null);
//       }
//     });
//   }
// }

function bottomnavposition () {
  const bn = $('.block-item.block-item-career-09');
  if ( !bn.length ) { return null }
  const bnHeight = bn.height();
  // const bnTop = bn.position().top;
  const bnOffsetTop = bn.offset().top;
  const winHeight = $(window).height();
  const bodyHeight = $('body').height();

  const scrollTop = $(window).scrollTop();

  let bnBottom = '';
  // console.log(bodyHeight - winHeight, scrollTop);
  if ( (bodyHeight - winHeight) <= (scrollTop + 50) ) {
    // bn.css({
    //   bottom: 50,
    // });
    bnBottom = 50 - ( (bodyHeight - winHeight) - scrollTop );
  } else {
    // bn.css({
    //   bottom: 10,
    // });
  }
  // console.log(bnBottom);
    bn.css({
      // bottom: 50,
      // bottom: 50 - ( (bodyHeight - winHeight) - scrollTop ),
      bottom: bnBottom,
    });


//     var offset = $(this).offset();
//     var blockStart = offset.top - 200;
//     var blockEnd = blockStart + $(this).height();

}

// document ready
$(function () {
  // variables
  
  /*web.pageRollUp = $('.page-roll-up');
  // functions
  web.pageRollUpToggle = function () {
    if ($(window).scrollTop() > 500) {
      this.pageRollUp.addClass('show');
    } else {
      this.pageRollUp.removeClass('show');
    }
  }; /**/


  $('.scrolltojoblist').click(function(e){
      e.preventDefault();
      var offset = $('.block-item-career-02').closest('.block-item').offset();
      $('html,body').animate(
        { scrollTop: offset.top - 50 },
        800,
        function () {
          //
        },
      );
  });
  $('.scrolltocontactform').click(function(e){
      e.preventDefault();
      var offset = $('#contact-form').closest('.block-item').offset();
      $('html,body').animate(
        { scrollTop: offset.top - 50 },
        800,
        function () {
          //
        },
      );
  });
  $('.scrolltoourvalues').click(function(e){
      e.preventDefault();
      var offset = $('.block-item.block-item-career-05 > div').offset();
      $('html,body').animate(
        { scrollTop: offset.top - 50 },
        800,
        function () {
          //
        },
      );
  });
  
  

  $('.career-bottom-nav a, a[data-blocktarget]').click(function(e){
      e.preventDefault();
      const ce = $(this);
      const ceTarget = ce.attr('data-blocktarget')
      const ceTargetEl = $('.block-item.block-item-career-' + ceTarget)

      if ( !ceTargetEl.length ) { return null; }
      
      const offset = ceTargetEl.offset();
      $('html,body').animate(
        { scrollTop: offset.top - 50 },
        800,
        function () {
          //
        },
      );
  });

  // web.pageRollUpToggle();
  // mainNavigationPosition();
  // lazyloadImages();

  // $('a[href*=".jpg"], a[href*="jpeg"], a[href*=".png"], a[href*=".gif"]').simpleLightbox();

  // $('.main-navbar .nav-link, .bhr-filtering a').click(function (e) {
  //   $('#main-nav-menu').collapse('hide');

  //   var t = $(this);
  //   var href = t.attr('href');
  //   var tUrl = new URL(href, window.location);
  //   var hrefUrl = tUrl.origin + tUrl.pathname;

  //   setTimeout(function () {
  //     var pageUrl = window.location.origin + window.location.pathname;

  //     if (hrefUrl === pageUrl && window.location.hash !== '') {
  //       var blockId = window.location.hash.slice(1);
  //       scrollToSection($, blockId);
  //     }
  //   }, 200);
  // });

  // $(window).scroll(function () {
  //   getnavposition($);
  // });

  // if (window.location.hash !== '') {
  //   var blockId = window.location.hash.slice(1);
  //   setTimeout(function () {
  //     scrollToSection($, blockId);
  //   }, 1000);
  // }

  // web.pageRollUp.click(function () {
  //   $('html, body').stop().animate(
  //     {
  //       scrollTop: 0,
  //     },
  //     800,
  //   );
  // });

  web.windowResize = function () {
    // $('.contact-map').height($(window).height() - $('.page-navigation').height());

    const windoWidth = $(window).width();
    const perksBlock = $('#block-perks');
    const perksBlock01 = perksBlock.find('.block-perk.block-perk-01');
    const perksBlock02 = perksBlock.find('.block-perk.block-perk-02');
    const perksBlock03 = perksBlock.find('.block-perk.block-perk-03');
    const perksBlock04 = perksBlock.find('.block-perk.block-perk-04');

    // console.log(!perksBlock.length);
    if( !perksBlock.length ) { return null; }

    if ( windoWidth < 992) {
      perksBlock.attr('style', null);
      perksBlock01.attr('style', null);
      perksBlock02.attr('style', null); 
      perksBlock03.attr('style', null); 
      perksBlock04.attr('style', null); 
    }
    // if (windoWidth < 768) {
    //   perksBlock01.css({
    //     top: 0,
    //     left: perksBlock.width() / 2 - perksBlock01.width() / 2 - 30,
    //   });
    //   perksBlock02.css({
    //     // 'top': perksBlock01.position().top + perksBlock01.height() - perksBlock01.height() / 2,
    //     top:
    //       perksBlock01.position().top +
    //       perksBlock01.height() -
    //       150,
    //     left: (perksBlock.width() - perksBlock02.width()) / 5,
    //   });
    //   perksBlock03.css({
    //     // 'top': perksBlock02.position().top + perksBlock02.height() - perksBlock02.height() / 2,
    //     top:
    //       perksBlock02.position().top +
    //       perksBlock02.height() -
    //       150,
    //     left: perksBlock.width() / 2 - perksBlock03.width() / 2,
    //   });
    //   perksBlock04.css({
    //     // 'top': perksBlock03.position().top + perksBlock03.height() - perksBlock03.height() / 2,
    //     top:
    //       perksBlock03.position().top +
    //       perksBlock03.height() -
    //       150,
    //     left: (perksBlock.width() - perksBlock02.width()) / 5,
    //   });
    //
    // perksBlock.height(perksBlock04.position().top + perksBlock04.height());
    // }


    // if (windoWidth <= 768) {
    //   perksBlock01.css({
    //     top: 0,
    //     left: perksBlock.width() / 2 - perksBlock01.width() / 2 - 30,
    //   });
    //   perksBlock02.css({
    //     // 'top': perksBlock01.position().top + perksBlock01.height() - perksBlock01.height() / 2,
    //     top:
    //       perksBlock01.position().top +
    //       perksBlock01.height() -
    //       150,
    //     left: (perksBlock.width() - perksBlock02.width()) / 5,
    //   });
    //   perksBlock03.css({
    //     // 'top': perksBlock02.position().top + perksBlock02.height() - perksBlock02.height() / 2,
    //     top:
    //       perksBlock02.position().top +
    //       perksBlock02.height() -
    //       150,
    //     left: perksBlock.width() / 2 - perksBlock03.width() / 2,
    //   });
    //   perksBlock04.css({
    //     // 'top': perksBlock03.position().top + perksBlock03.height() - perksBlock03.height() / 2,
    //     top:
    //       perksBlock03.position().top +
    //       perksBlock03.height() -
    //       150,
    //     left: (perksBlock.width() - perksBlock02.width()) / 5,
    //   });

    // perksBlock.height(perksBlock04.position().top + perksBlock04.height());
    // }

    // if (windoWidth <= 992 && windoWidth > 768) {
    //   perksBlock01.css({
    //     top: 0,
    //     left: perksBlock.width() / 2.5 - perksBlock01.width() / 2,
    //   });
    //   console.log(perksBlock01.position().top +
    //       perksBlock01.find('p').position().top +
    //       perksBlock01.find('p').height() +
    //       50);
    //   perksBlock02.css({
    //     // 'top': perksBlock01.position().top + perksBlock01.height() - perksBlock01.height() / 2,
    //     top:
    //       perksBlock01.position().top +
    //       perksBlock01.find('p').position().top +
    //       perksBlock01.find('p').height() +
    //       50,
    //     left: (perksBlock.width() - perksBlock.width() / 2 - perksBlock02.width() / 2 - perksBlock02.width() / 4),
    //   });
    //   perksBlock03.css({
    //     // 'top': perksBlock02.position().top + perksBlock02.height() - perksBlock02.height() / 2,
    //     top:
    //       perksBlock02.position().top +
    //       perksBlock02.find('p').position().top +
    //       perksBlock02.find('p').height() +
    //       50,
    //     left: perksBlock02.position().left + perksBlock02.width() - perksBlock02.width() / 4,
    //   });
    //   perksBlock04.css({
    //     // 'top': perksBlock03.position().top + perksBlock03.height() - perksBlock03.height() / 2,
    //     top:
    //       perksBlock03.position().top +
    //       perksBlock03.find('p').position().top +
    //       perksBlock03.find('p').height() +
    //       50,
    //     left: perksBlock.width() / 2 - perksBlock04.width() / 2 - perksBlock04.width() / 5,
    //   });

    // perksBlock.height(perksBlock04.position().top + perksBlock04.height());
    // }

    if (windoWidth > 992) {
      perksBlock01.css({
        top: 0,
        left: perksBlock.width() / 2.5 - perksBlock01.width() / 2,
      });
      perksBlock02.css({
        // 'top': perksBlock01.position().top + perksBlock01.height() - perksBlock01.height() / 2,
        top:
          perksBlock01.position().top +
          perksBlock01.find('p').position().top +
          perksBlock01.find('p').height() +
          50,
        left: (perksBlock.width() / 2 - perksBlock02.width() / 2) - perksBlock02.width() / 2,
      });
      perksBlock03.css({
        // 'top': perksBlock02.position().top + perksBlock02.height() - perksBlock02.height() / 2,
        top:
          perksBlock02.position().top +
          perksBlock02.find('p').position().top +
          perksBlock02.find('p').height() +
          50,
        left: perksBlock02.position().left + perksBlock02.width() - perksBlock02.width() / 4,
      });
      perksBlock04.css({
        // 'top': perksBlock03.position().top + perksBlock03.height() - perksBlock03.height() / 2,
        top:
          perksBlock03.position().top +
          perksBlock03.find('p').position().top +
          perksBlock03.find('p').height() +
          50,
        left: perksBlock.width() / 2 - perksBlock04.width() / 2 - perksBlock04.width() / 5,
      });

    perksBlock.height(perksBlock04.position().top + perksBlock04.height());
    }
  };

  // $('[data-bs-toggle="tooltip"]').tooltip();

  $(window).scroll(); // initial scroll call

  // on scroll actions
  $(window).scroll(function () {
    // web.pageRollUpToggle();
    // lazyloadImages();
    // mainNavigationPosition();
    bottomnavposition();
  });

  // on resize actions
  web.windowResize();
  $(window).resize(function () {
    web.windowResize();
  });
});

// cookies consent management --------------
// ar.docReady(function () {
//   ar.cookiesConsent();
// });
// END - cookies consent management --------------
